/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_All_ButtonInputs */

const en_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const fr_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout`)
};

const de_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const it_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto`)
};

const ru_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все`)
};

const es_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo`)
};

const zh_cn2_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const ja_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全て`)
};

const hi_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी`)
};

const pt_pt2_spellcheck_all_button = /** @type {(inputs: Spellcheck_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Spellcheck_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_all_button = /** @type {((inputs?: Spellcheck_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_all_button(inputs)
	if (locale === "de") return de_spellcheck_all_button(inputs)
	if (locale === "it") return it_spellcheck_all_button(inputs)
	if (locale === "ru") return ru_spellcheck_all_button(inputs)
	if (locale === "es") return es_spellcheck_all_button(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_all_button(inputs)
	if (locale === "ja") return ja_spellcheck_all_button(inputs)
	if (locale === "hi") return hi_spellcheck_all_button(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_all_button(inputs)
	return en_spellcheck_all_button(inputs)
});